export interface WebAuthnRpConfig {
  rpID: string;
  rpName: string;
  origin: string;
}

/** Client RP config from Vite env (cosmetic / browser options only). */
export function resolveClientWebAuthnRp(env: {
  rpID?: string;
  origin?: string;
  hostname?: string;
  rpName?: string;
}): WebAuthnRpConfig {
  const hostname = env.hostname || 'localhost';
  const rpID = String(env.rpID || hostname).trim() || 'localhost';
  const origin = String(env.origin || (hostname === 'localhost'
    ? 'http://localhost:5173'
    : `https://${hostname}`)).trim();
  const rpName = String(env.rpName || '').trim() || rpID;
  return {
    rpID,
    rpName,
    origin,
  };
}

export const DEVICE_SESSION_STORAGE_KEY = 'alea.device.session';
export const PASSKEY_CREDENTIAL_HINT_KEY = 'alea.passkey.credentialId';
